// @flow

import React from 'react';
import Tooltip from '../../../../../components/Tooltip';

type Props = {
  image: string,
  value: string,
  label: string,
  imageClassName?: string,
  tooltip: string,
};

class KeyFigureTile extends React.PureComponent<Props> {
  render() {
    if (!this.props.value) {
      return false;
    }

    return (
      <div className="key-figure-tile">
        <div className="key-figure-header">
          <div className="flex-filler" />
          <img className={this.props.imageClassName || ''} alt="logo" src={this.props.image} />
          <div className="information-container">
            <Tooltip>
              <div className="marketing-tooltip">
                {this.props.tooltip}
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="key-figure-value">
          {this.props.value}
        </div>
        <div className="key-figure-label">
          {this.props.label}
        </div>
      </div>
    );
  }
}

export default KeyFigureTile;
